import { SiteDirection } from "../../data";
const baseClass = "rj-superbanner";
function toUpperCase(str) {
    return str.toUpperCase();
}
function getSide(siteDir, side) {
    return siteDir === SiteDirection.rightToLeft ?
        side === "left" ? "right" : "left" :
        side;
}
function getBannerModifier(props) {
    let mod = getSide(props.siteDir, props.side).replace(/^(.)/g, toUpperCase);
    return props.scrollability[props.side] ? ` ${baseClass}--s${mod}` : "";
}
function getBannerModeModifier(props) {
    return !props.isMultipleItemsModeEnabled ? ` ${baseClass}--desktop-full-view` : "";
}
function getBannerDragModifier(draggable) {
    return draggable ? ` ${baseClass}--draggable` : "";
}
function getMobileModeModifier(props) {
    return props.isMobileMode ? ` ${baseClass}--mobile-small-view` : "";
}
export function getBannerClasses(props) {
    let leftProps = Object.assign(Object.assign({}, props), { side: "left" });
    let rightProps = Object.assign(Object.assign({}, props), { side: "right" });
    return `${baseClass}${getBannerModeModifier(props)}` +
        `${getBannerModifier(leftProps)}${getBannerModifier(rightProps)}` +
        `${getBannerDragModifier(props.draggability)}${getMobileModeModifier(props)}`;
}
//# sourceMappingURL=GetBannerClasses.js.map